import r2wc from '@r2wc/react-to-web-component';
import { windowIsDefined } from '@klv/shared/utils/functions';
import * as styles from './styles/klv-modal.module.scss';

export interface IKlvModalProps {
  modalId: string;
  buttonText: string;
}

export const KlvModalWrapper = ({ modalId, buttonText }: IKlvModalProps) => {
  const handleClick = () => {
    window.dispatchEvent(
      new CustomEvent('open-klv-modal', { detail: { modalId } }),
    );
  };

  return (
    <button
      type="button"
      className={styles.buttonText}
      aria-label={buttonText}
      onClick={handleClick}
    >
      <span>{buttonText}</span>
    </button>
  );
};

const KlvModal = r2wc(KlvModalWrapper, {
  props: {
    modalId: 'string',
    buttonText: 'string',
  } as Record<keyof IKlvModalProps, 'string'>,
});

export const registerKlvModal = () => {
  if (windowIsDefined() && !customElements.get('klv-modal')) {
    customElements.define('klv-modal', KlvModal);
  }
}; 
